var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5017 41.2832C12.1447 41.2832 3.71875 32.8572 3.71875 22.5003C3.71875 12.1432 12.1447 3.71725 22.5017 3.71725C32.8586 3.71725 41.2846 12.1432 41.2846 22.5003C41.2846 32.8572 32.8586 41.2832 22.5017 41.2832Z",
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5011 33.7246C16.3122 33.7246 11.2773 28.6897 11.2773 22.5009C11.2773 16.3121 16.3122 11.2772 22.5011 11.2772C28.6899 11.2772 33.7248 16.3121 33.7248 22.5009C33.7248 28.6897 28.6899 33.7246 22.5011 33.7246Z",
    fill: "url(#paint0_linear_2727_268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 33L24 33.5H22L20.5 33C20 32.6667 18.4 32.5 18 32.5C17.6 32.5 17.3333 31.6667 17 31.5L15.5 31L16 30V28.5C16 28 16.5 27.5 16.5 27C16.5 26.6 17.1667 26.1667 17.5 26C18.5 25.5 20.6 24.5 21 24.5C21.4 24.5 22.5 24.1667 23 24L24.5 24.5C25.5 24.8333 27.6 25.6 28 26L29.5 27.5V29.5V31L28 32L27 33Z",
    fill: "#EBF5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5011 33.7246C16.3122 33.7246 11.2773 28.6897 11.2773 22.5009C11.2773 16.3121 16.3122 11.2772 22.5011 11.2772C28.6899 11.2772 33.7248 16.3121 33.7248 22.5009C33.7248 28.6897 28.6899 33.7246 22.5011 33.7246Z",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.4043V0.00030297",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45V37.9491",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5977 22.5H45.0017",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5H7.05094",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5706 19.6605V20.3631C25.5706 22.0577 24.1968 23.4316 22.5021 23.4316C20.8074 23.4316 19.4336 22.0577 19.4336 20.3631V19.6605C19.4336 17.9658 20.8074 16.592 22.5021 16.592C24.1968 16.592 25.5706 17.9658 25.5706 19.6605Z",
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3594 31.1523V28.6127C15.3594 27.1942 16.2262 25.92 17.5454 25.3988L22.5015 23.4413",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.4413L27.4562 25.3988C28.7753 25.92 29.6422 27.1942 29.6422 28.6126V31.1523",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_268",
    x1: 14.5,
    y1: 11.5,
    x2: 30.5,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135076,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiting);
export default __webpack_public_path__ + "static/media/Recruiting.e1d623beb81e63f4534a8e81175b027f.svg";
export { ForwardRef as ReactComponent };